import { createSelector } from 'reselect';
import {
  ROUTE_COURSE_PAGE,
  ROUTE_BLOCKPAGE_CONTENT,
  ROUTE_BLOCK_WIDGET,
} from '../../routeActions';
import { routeIsInCourseWithQueryParam } from './constants';
import { selectLocationState } from '../selectors';
import { coursePathFromPagePath } from '../../helpers/paths';

export const selectCurrentCoursePath = createSelector(
  [selectLocationState],
  (location) => {
    if (location.type === ROUTE_COURSE_PAGE) {
      const { institutionPrefix } = location.state || {};
      if (institutionPrefix) {
        return `${institutionPrefix.toLowerCase()}/courses/${location.params.courseCode.toLowerCase()}`;
      } else {
        return `courses/${location.params.courseCode.toLowerCase()}`;
      }
    } else if (
      location.type === ROUTE_BLOCKPAGE_CONTENT ||
      location.type === ROUTE_BLOCK_WIDGET
    ) {
      const pagePath = location.query.path;
      return coursePathFromPagePath(pagePath);
    } else if (routeIsInCourseWithQueryParam(location)) {
      return location.query.course.toLowerCase();
    } else {
      return null; // A routing action for another page
    }
  }
);
